import { Vue } from 'vue-property-decorator'

export const organizationalStructurePropertyType = () => {
  return {
    VALUE_TEXT: { key: 50620001, label: Vue.prototype.$gettext('ORGANIZATIONAL_STRUCTURE_PROPERTY_TYPE.50620001') },
    VALUE_NUMBER: { key: 50620002, label: Vue.prototype.$gettext('ORGANIZATIONAL_STRUCTURE_PROPERTY_TYPE.50620002') },
    VALUE_FLOAT: { key: 50620003, label: Vue.prototype.$gettext('ORGANIZATIONAL_STRUCTURE_PROPERTY_TYPE.50620003') },
    VALUE_DATE: { key: 50620004, label: Vue.prototype.$gettext('ORGANIZATIONAL_STRUCTURE_PROPERTY_TYPE.50620004') },
    VALUE_COMBO: { key: 50620005, label: Vue.prototype.$gettext('ORGANIZATIONAL_STRUCTURE_PROPERTY_TYPE.50620005') }
  }
}
